import { createElement } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import BootstrapBadge from '../bootstrap/Badge.js';
function Badge(_ref) {
  let {
    className,
    circle = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/createElement(BootstrapBadge, {
    className: clsx(className, {
      'badge-circle': circle
    }),
    ...rest
  });
}
export default Badge;